// urlMarkDown
export function urlMarkDown(markdownService) {
	'ngInject';

	return hyperlink => {
		const url = markdownService.markdownToUrl(hyperlink);
		return `<a href="${url.url}" target="_blank">${url.text}</a>`;
	};
}

// urlTextMarkdown
export function urlTextMarkdown(markdownService) {
	'ngInject';

	return hyperlink => {
		if (hyperlink) {
			const url = markdownService.markdownToUrl(hyperlink);
			return url.text;
		}
		return;
	};
}
